/**
 * のれんシミュレーター → カスタムのれん注文フォーム（MAG Form Builder）の受け渡し
 *
 * シミュレーターの「Request a quote with this design」が sessionStorage に入れた
 *   { size, details, image(JPEG の data URL), fileName }
 * を、MAG のフォームの Size・Details・File 欄に入れる。送信は MAG がそのまま行う。
 *
 * MAG はアプリ側でフォームを描くため、項目名や HTML が変わると入れられなくなる。
 * そのときはお客様に手で添付してもらう案内に切り替え、<html data-noren-bridge> に結果を残す
 * （scripts/check-mag-form.mjs がこの値を見て、連動が壊れていないかを確かめる）。
 */
(function () {
  const KEY = 'noren-simulator:order';
  const MAX_AGE_MS = 24 * 60 * 60 * 1000;
  const WAIT_MS = 20000;

  // MAG の項目は「ラベル名」が name になる。管理画面でラベルを変えたらここも合わせる
  const FIELDS = {
    form: 'form.mag-element-form',
    size: (form) => form.querySelector('[name="Size"], [data-label="Size"]'),
    details: (form) => form.querySelector('textarea[name^="Details"], textarea[data-label^="Details"]') || form.querySelector('textarea'),
    file: (form) => form.querySelector('input[type="file"]'),
  };

  const root = document.documentElement;
  const notice = document.querySelector('[data-noren-bridge-notice]');

  let payload = null;
  try {
    payload = JSON.parse(sessionStorage.getItem(KEY) || 'null');
  } catch {
    payload = null;
  }
  if (!payload) return;
  if (Date.now() - payload.createdAt > MAX_AGE_MS) {
    sessionStorage.removeItem(KEY);
    return;
  }

  function setValue(el, value) {
    el.value = value;
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function dataUrlToFile(dataUrl, name) {
    const [head, body] = dataUrl.split(',');
    const type = head.match(/data:([^;]+)/)[1];
    const bin = atob(body);
    const bytes = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return new File([bytes], name, { type });
  }

  function attach(input) {
    const accept = (input.accept || '').toLowerCase();
    if (accept && !/\.jpe?g|image\/jpeg|image\/\*/.test(accept)) return false;
    try {
      const dt = new DataTransfer();
      dt.items.add(dataUrlToFile(payload.image, payload.fileName || 'noren-design.jpg'));
      input.files = dt.files;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return input.files.length === 1;
    } catch {
      return false;
    }
  }

  function showNotice(result) {
    if (!notice) return;
    const ok = result.size && result.details && result.file;
    notice.hidden = false;
    notice.querySelector('[data-noren-bridge-thumb]').src = payload.image;
    notice.querySelector('[data-noren-bridge-message]').textContent = ok
      ? 'Your design from the simulator has been added to the form below: size, details and the design image. Add your contact details and send.'
      : 'Your design details have been added to the form below. Please add the design image you saved from the simulator in the File field.';
    notice.querySelector('[data-noren-bridge-clear]').onclick = () => {
      sessionStorage.removeItem(KEY);
      location.reload();
    };
  }

  function fill(form) {
    const size = FIELDS.size(form);
    const details = FIELDS.details(form);
    const file = FIELDS.file(form);
    const result = { size: false, details: false, file: false };
    if (size && !size.value) {
      setValue(size, payload.size);
      result.size = true;
    } else if (size) {
      result.size = true;
    }
    if (details) {
      // お客様がすでに書いた内容は残し、シミュレーターの仕様を先頭に入れる
      const current = details.value.trim();
      if (!current.includes(payload.details)) setValue(details, current ? `${payload.details}\n\n${current}` : payload.details);
      result.details = true;
    }
    if (file) result.file = attach(file);
    root.dataset.norenBridge = result.size && result.details && result.file ? 'filled' : 'partial';
    root.dataset.norenBridgeDetail = JSON.stringify(result);
    if (!result.size || !result.details || !result.file) console.warn('[noren-bridge] some MAG fields could not be filled', result);
    showNotice(result);
    // 送信したら受け渡しは終わり。次にフォームを開いたときに古いデザインを入れない
    form.addEventListener('submit', () => sessionStorage.removeItem(KEY), { capture: true });
  }

  const started = Date.now();
  const find = () => {
    const form = document.querySelector(FIELDS.form);
    if (form && FIELDS.file(form)) {
      observer.disconnect();
      fill(form);
      return;
    }
    if (Date.now() - started > WAIT_MS) {
      observer.disconnect();
      root.dataset.norenBridge = 'no-form';
      console.warn('[noren-bridge] MAG form was not found');
    }
  };
  const observer = new MutationObserver(find);
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(find, 0);
  setTimeout(find, WAIT_MS + 50);
})();
